import { authService } from '@/services/authService';
import { AuthServiceEnum } from '@/util/auth/enums';
const fetchWithToken = async (url, method = 'GET', body = {}) => {
    try {
        const idToken = await authService.getTokenSilent(AuthServiceEnum.ACQUIRE_TOKEN_REDIRECT);
        console.log('idToken: ', idToken);
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${idToken}`
            },
            mode: 'cors',
            ...(Object.keys(body).length && { body: JSON.stringify(body) })
        });
        return response;
    }
    catch (error) {
        console.error(error);
        throw error;
    }
};
export default fetchWithToken;
